import classNames from 'classnames';
import ListItemContent from '@alltrails/denali/components/ListItemContent';
import Sparkle from '@alltrails/denali/icons/Sparkle';
import ResultItem from '../../../FullscreenSearchBox/results/ResultItem';
import styles from '../../styles/styles.module.scss';

type Props = {
  handleOnAiSearch: () => void;
  query: string;
  isActive?: boolean;
};

const NlSearchResult = ({ handleOnAiSearch, query, isActive }: Props) => {
  const icon = (
    <div className={styles.iconContainer}>
      <Sparkle color="--color-text-secondary" />
    </div>
  );

  return (
    <ResultItem isActive={isActive} onClick={handleOnAiSearch}>
      <ListItemContent
        className={classNames(styles.listItemContent, styles.noDescription)}
        leftContent={icon}
        label={<div className={styles.label}>{query}</div>}
        testId="nl-search"
      />
    </ResultItem>
  );
};

export default NlSearchResult;
